export const getCategoryFromUrl = (url: string) => {
    const urlData = url.split('catalog/');

    if (urlData && urlData[1]) {
        return urlData[1].split('/')[0].split('?')[0];
    }
    return '';
};
